import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RENDERER_TYPES} from "../constants";
import {languageSelector, languagesSelector} from "../../../state/app/appSelectors";
import {localizeI18nObj} from "../../../utils/i18n";
import {isFieldSelect} from "../utils";

export const SelectTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.select || isFieldSelect(schema));

export const SelectRenderer = withJsonFormsControlProps(
  ({data, handleChange, path, label, schema, id, required, errors}) => {
    const {t} = useTranslation();
    const language = useSelector(languageSelector);
    const languages = useSelector(languagesSelector);

    const options = schema?.elements?.filter(el => el.__Guid) || [];
    const isMultiple = schema?.options?.multiple || false;

    const handleSelectChange = event => {
      handleChange(path, event.target.value);
    };

    const isError = Boolean(errors && errors.length > 0);

    return (
      <FormControl fullWidth required={required} error={isError}>
        <InputLabel>{label}</InputLabel>
        <Select
          id={id}
          multiple={isMultiple}
          value={data || (isMultiple ? [] : "")}
          onChange={handleSelectChange}
          label={label}
          renderValue={selected => {
            if (isMultiple) {
              const selectedOptions = options
                .filter(option => selected.includes(option.__Guid))
                .map(option => localizeI18nObj(option.title, language, languages));
              return selectedOptions.join(", ");
            } else {
              const selectedOption = options.find(option => option.__Guid === selected);
              return selectedOption ? localizeI18nObj(selectedOption.title, language, languages) : selected;
            }
          }}
        >
          <MenuItem value={""}>
            <em>{t("components.customJsonForms.selectRenderer.menuItem.none.title")}</em>
          </MenuItem>
          {options.map(option => (
            <MenuItem key={option.__Guid} value={option.__Guid}>
              <ListItemText
                primary={option.title ? localizeI18nObj(option.title, language, languages) : option.__Guid}
              />
            </MenuItem>
          ))}
        </Select>
        {isError && <FormHelperText>{errors}</FormHelperText>}
      </FormControl>
    );
  }
);
